const headHotelInfo = {
  props: {
    dynamicClass: ".c-head-hotel-info.dynamicLoading",
  },

  init: function () {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-headHotelInfo.css", this.props.dynamicClass);
  },
};

export default headHotelInfo;
